<template>
  <div class="no-login-service-list">
    <service-list :service-list="serviceList"></service-list>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
import ServiceList from './service-list/service-list.vue';
import PopoverFollowUs from './popover/popover-follow-us';
import PopoverCustomer from './popover/popover-customer';
import followUsImage from '../../../assets/imgs/homepage/fixed-right-service/service-follow-us.png';
import followUsActiveImage from '../../../assets/imgs/homepage/fixed-right-service/service-follow-us-active.png';
import freeRegistryImage from '../../../assets/imgs/homepage/fixed-right-service/service-free-registry.png';
import freeRegistryActiveImage from '../../../assets/imgs/homepage/fixed-right-service/service-free-registry-active.png';
import customerImage from '../../../assets/imgs/homepage/fixed-right-service/service-customer.png';


export default {
  props: {},
  components: {
    ServiceList,
    PopoverFollowUs,
    PopoverCustomer,
  },
  data() {
    return {
      serviceList: [
        {
          name: '关注我们',
          defaultImage: followUsImage,
          hoverImage: followUsActiveImage,
          popover: PopoverFollowUs,
        },
        {
          name: '免费注册',
          defaultImage: freeRegistryImage,
          hoverImage: freeRegistryActiveImage,
          clickHandler: () => {
            this.SHOW_LOGIN_BOX({ page: 5 });
          },
        },
        {
          name: '客服咨询',
          defaultImage: customerImage,
          type: 'hotline',
          popover: PopoverCustomer,
        },
      ],

    };
  },
  methods: {
    ...mapMutations(['SHOW_LOGIN_BOX']),
  },
};
</script>

<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/components/fixed-right-service/components/no-login-service-list.vue